module.exports = __webpack_public_path__ + "img/placeholder3.987701c9.jpg";